import { ColoursObj } from "@eventr/common-storybook";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";

interface IExpandProps {
  expanded: boolean;
  past?: boolean;
  colour?: string;
}

export const Expand = ({ expanded, past = false, colour = ColoursObj.core.primary }: IExpandProps) => {
  return (
    <ExpandLessRoundedIcon
      sx={{
        color: past ? ColoursObj.shades.shade2 : colour,
        transition: "transform 0.3s ease, color 0.3s ease",
        transform: expanded ? "scaleY(1)" : "scaleY(-1)",
      }}
    />
  );
};
